// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function detranCnhClear(): ReducerAction {
	return {
		type: Types.DETRAN_CNH_CLEAR,
		payload: null,
	};
}
